import { Component, OnInit } from '@angular/core';
import { MemberService } from 'src/app/services/member.service';
import { RoleService } from 'src/app/services/role.service';
import { Member } from 'src/app/model/member';
import { BoardRole } from 'src/app/model/role';
import { RoleType } from 'src/app/model/role-type';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'committee',
  templateUrl: 'committee.html',
})

export class CommitteeComponent implements OnInit {
  members: [Member, BoardRole][];

  constructor(
    private readonly memberService: MemberService,
    private readonly roleService: RoleService
  ) { }

  ngOnInit(): void {
    this.getBoardMembers();
  }

  getBoardMembers(): void {
    this.members = [];
    // get members
    forkJoin([this.roleService.getBoardRoles(), this.memberService.getMembers()]).subscribe(results => {
      let roles: BoardRole[] = results[0];
      let members: Member[] = results[1];
      members.forEach(member => member.roleIds.forEach(roleId => {
        let role: BoardRole = roles.find(role => role.roleId === roleId);
        if (role) {
          this.members.push([member, role]);
        }
      }));
      this.members = this.members.sort(function(a,b) {
        return a[1].priority < b[1].priority ? -1 : (a[1].priority > b[1].priority ? 1 : 0);
      });
    });
  }
}
